import SkeletonCardList from 'components/skeleton/skeleton-card-list/SkeletonCardList';
import React from 'react';
import { NotePencil } from '@phosphor-icons/react';
import tw, { styled } from 'twin.macro';

import { Modal } from 'components/page/app-page/Modal';
import Budget from 'components/payment/Budget';
import { useBudgetModal } from 'components/payment/useBudgetModal';

const SocialStats: React.FC<{
  loading: boolean;
  applications?: number | null;
  spent: number;
  totalBudget?: number | null;
  showApplications?: boolean;
  onSubmit?: () => void;
}> = ({
  loading,
  applications = 0,
  spent,
  totalBudget = 0,
  showApplications = true,
  onSubmit,
}) => {
  const budgetModal = useBudgetModal();

  if (loading)
    return (
      <div tw="mb-4 sm:(mt-4) xl:(ml-6 mt-8 w-96)">
        <SkeletonCardList variant="sm" cards={3} />
      </div>
    );

  return (
    <Wrapper>
      <Modal
        show={budgetModal.isOpen}
        onClose={budgetModal.dismiss}
        hideCloseButton={budgetModal.isSubmitting}
      >
        <Budget
          title={'Add budget to your campaign'}
          cta={'Increase budget'}
          closeModal={budgetModal.complete}
          onSubmittingChange={budgetModal.onSubmittingChange}
          isSubmitting={budgetModal.isSubmitting}
          onSubmit={onSubmit}
        />
      </Modal>

      {showApplications && (
        <StatItem>
          <StatLabel>Applications</StatLabel>
          <Stat>{applications}</Stat>
        </StatItem>
      )}

      <StatItem>
        <StatLabel>Total spent</StatLabel>
        <Stat>€ {spent}</Stat>
      </StatItem>

      <StatItem
        pointer={!budgetModal.isSubmitting}
        tabIndex={budgetModal.isSubmitting ? -1 : 1}
        aria-disabled={budgetModal.isSubmitting}
        onClick={budgetModal.open}
      >
        <StatLabel>Budget</StatLabel>
        <div tw="flex justify-end items-center w-full">
          <NotePencil weight="bold" tw="text-indigo-500 mr-2" size="18" />
          <Stat tw="sm:ml-0">€ {totalBudget}</Stat>
        </div>
      </StatItem>
    </Wrapper>
  );
};

const Wrapper = styled.ul(
  tw`
    flex flex-row justify-between my-auto gap-8 overflow-x-auto max-w-full
    xl:(overflow-x-hidden)
  `
);

const StatItem = styled.li<{ pointer?: boolean }>`
  ${tw`
    flex flex-col gap-1 items-end
    sm:(items-end pb-0)
  `}
  ${({ pointer }) => pointer && tw`cursor-pointer`}
`;

const StatLabel = styled.span(
  tw`text-gray-400 w-full whitespace-nowrap text-right`
);

const Stat = styled.span(
  tw`
    text-2xl font-extrabold text-gray-700 whitespace-nowrap
    sm:(ml-auto text-right)
  `
);

export default SocialStats;
